var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"chart-container",attrs:{"option":_vm.option,"update-options":_vm.updateOptions,"autoresize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }